import FileSaver from "file-saver";
import { List } from "immutable";
import PubSub from "pubsub-js";

import PubSubTopics from "../constants/pubSubTopics";
import { generateCsvString } from "../dataConversion/csvFormat";
import v3ToStandardConverter from "../dataConversion/standardFormat/v3toStandardConverter";
import loadData from "../loadData";
import {
  isNativeCommsInstalled,
  messageTypes as nativeCommsBroadcastMessageTypes
} from "../nativeComms/nativeCommsBroadcaster";

const exportTsfFile = (state, attachmentPath, disableFiltering, disableSplitView, disableTimelineZoom, skin) => {
  const standardData = v3ToStandardConverter(
    state,
    attachmentPath,
    disableFiltering,
    disableSplitView,
    disableTimelineZoom,
    skin
  );
  if (isNativeCommsInstalled()) {
    PubSub.publish(PubSubTopics.sendNativeMessage, {
      msg: nativeCommsBroadcastMessageTypes.EXPORT_DATA_TSF,
      data: JSON.stringify(standardData)
    });
  } else {
    const jsonStr = JSON.stringify(standardData, undefined, 2);
    const blob = new Blob([jsonStr], { type: "application/json" });

    const filename = `standard_timeline_${new Date().toISOString()}.tsf`;
    FileSaver.saveAs(blob, filename);
  }
};

const exportCsvFile = (state, delimiter, typeIds, isSelectedItemsOnly) => {
  const csvStr = generateCsvString(state, delimiter, typeIds, isSelectedItemsOnly);
  if (isNativeCommsInstalled()) {
    PubSub.publish(PubSubTopics.sendNativeMessage, {
      msg: nativeCommsBroadcastMessageTypes.EXPORT_DATA_CSV,
      data: csvStr,
      delimiter
    });
  } else {
    const blob = new Blob([csvStr], { type: "application/json" });

    const filename = `csv_timeline_${new Date().toISOString()}.csv`;
    FileSaver.saveAs(blob, filename);
  }
};

const transferPersistentState = (newState, oldState) => {
  const oldPresent = oldState.present ? oldState.present : null;
  return oldPresent
    ? newState.withMutations(ns => {
      ns.set("isDataLoaded", true);
      ns.set("preferences", oldPresent.preferences);
      ns.set("autoUpdates", oldPresent.autoUpdates);
      ns.set("registration", oldPresent.registration);
      ns.set("mobileScreen", oldPresent.mobileScreen);
      ns.set("tutorial", oldPresent.tutorial);
      ns.setIn(["uiState", "fileName"], oldPresent.uiState.fileName);
      ns.setIn(["welcome", "recentFiles"], oldPresent.welcome.recentFiles);
    })
    : newState.set("isDataLoaded", true);
};

const updateFile = (state, action) => {
  // If the user chooses "UPDATE_FILE" then we only want to replace select parts of our data
  // while keeping the appState and uiState in tact. That will prevent the user being thrown
  // out of views unnecessarily
  // ---- Updated: 05 Aug 2021 ----
  // We decided to sync all the updated data to avoid any potential errors.
  // See https://bitbucket.org/aeontimeline/aeon-timeline-react/pull-requests/820#comment-240469563

  let updatedState = loadData.plainJsToTimelineRecord(action.data, action.charWidthMap);
  updatedState = transferPersistentState(updatedState, state);

  return {
    past: List(),
    present: updatedState,
    future: List(),
    lastActionUndo: false,
    lastActionRedo: false
  };
};

export { exportCsvFile, exportTsfFile, transferPersistentState, updateFile };
